var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native-web");
var _simpleMarkdown = _interopRequireDefault(require("simple-markdown"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports["default"] = Object.assign({}, _simpleMarkdown["default"].defaultRules.em, {
  react: function react(node, output, state) {
    var _useStyles = (0, _styles.useStyles)({
        sharedStyles: state.sharedStyles
      }),
      styles = _useStyles.styles;
    return (0, _jsxRuntime.jsx)(_reactNative.Text, {
      textBreakStrategy: "simple",
      style: styles.em,
      children: output(node.content, state)
    }, state.key);
  }
});